var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TubularDeviceBoxAdapter_instances, _TubularDeviceBoxAdapter_context, _TubularDeviceBoxAdapter_box, _TubularDeviceBoxAdapter_parametric, _TubularDeviceBoxAdapter_wrapParameters;
import { Option, StringMapping, ValueMapping } from "@opendaw/lib-std";
import { VoicingMode } from "@opendaw/studio-enums";
import { Devices } from "../../DeviceAdapter";
import { DeviceManualUrls } from "../../DeviceManualUrls";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
import { TrackType } from "../../timeline/TrackType";
export var Tubular;
(function (Tubular) {
    Tubular.Algorithms = Array.from({ length: 32 }, (_, index) => String(index + 1));
    Tubular.Curves = ["-LIN", "-EXP", "+EXP", "+LIN"];
    Tubular.Modes = ["Ratio", "Fixed"];
    Tubular.Detunes = Array.from({ length: 15 }, (_, index) => index === 7 ? "0" : index > 7 ? `+${index - 7}` : String(index - 7));
    Tubular.LfoWaves = ["Triangle", "Saw Down", "Saw Up", "Square", "Sine", "S&H"];
    Tubular.Switch = ["Off", "On"];
    // The 32 algorithms as msfa bus flags per operator in SYSEX order (OP6 first): bits 0-1 out bus (0 =
    // output), bit 2 add to bus, bits 4-5 in bus, bits 6-7 feedback. Mirrors `ALGORITHMS` in fm.rs.
    const ALGORITHMS = [
        [0xc1, 0x11, 0x11, 0x14, 0x01, 0x14], [0x01, 0x11, 0x11, 0x14, 0xc1, 0x14], [0xc1, 0x11, 0x14, 0x01, 0x11, 0x14],
        [0xc1, 0x11, 0x94, 0x01, 0x11, 0x14], [0xc1, 0x14, 0x01, 0x14, 0x01, 0x14], [0xc1, 0x94, 0x01, 0x14, 0x01, 0x14],
        [0xc1, 0x11, 0x05, 0x14, 0x01, 0x14], [0x01, 0x11, 0xc5, 0x14, 0x01, 0x14], [0x01, 0x11, 0x05, 0x14, 0xc1, 0x14],
        [0x01, 0x05, 0x14, 0xc1, 0x11, 0x14], [0xc1, 0x05, 0x14, 0x01, 0x11, 0x14], [0x01, 0x05, 0x05, 0x14, 0xc1, 0x14],
        [0xc1, 0x05, 0x05, 0x14, 0x01, 0x14], [0xc1, 0x05, 0x11, 0x14, 0x01, 0x14], [0x01, 0x05, 0x11, 0x14, 0xc1, 0x14],
        [0xc1, 0x11, 0x02, 0x25, 0x05, 0x14], [0x01, 0x11, 0x02, 0x25, 0xc5, 0x14], [0x01, 0x11, 0x11, 0xc5, 0x05, 0x14],
        [0xc1, 0x14, 0x14, 0x01, 0x11, 0x14], [0x01, 0x05, 0x14, 0xc1, 0x14, 0x14], [0x01, 0x14, 0x14, 0xc1, 0x14, 0x14],
        [0xc1, 0x14, 0x14, 0x14, 0x01, 0x14], [0xc1, 0x14, 0x14, 0x01, 0x14, 0x04], [0xc1, 0x14, 0x14, 0x14, 0x04, 0x04],
        [0xc1, 0x14, 0x14, 0x04, 0x04, 0x04], [0xc1, 0x05, 0x14, 0x01, 0x14, 0x04], [0x01, 0x05, 0x14, 0xc1, 0x14, 0x04],
        [0x04, 0xc1, 0x11, 0x14, 0x01, 0x14], [0xc1, 0x14, 0x01, 0x14, 0x04, 0x04], [0x04, 0xc1, 0x11, 0x14, 0x04, 0x04],
        [0xc1, 0x14, 0x04, 0x04, 0x04, 0x04], [0xc4, 0x04, 0x04, 0x04, 0x04, 0x04]
    ];
    // Each operator's role in `algorithm` (0-based), indexed by PANEL operator (0 = OP1): what it modulates
    // (panel numbers 1-6), whether it reaches the output, whether it feeds back into itself. Follows the
    // engine's bus walk: an operator writing a bus replaces (or adds to) its content, a reader takes all
    // current writers.
    Tubular.roles = (algorithm) => {
        const flags = ALGORITHMS[Math.max(0, Math.min(31, algorithm))];
        const result = Array.from({ length: 6 }, () => ({ carrier: false, targets: [], feedback: false }));
        const writers = [[], []];
        flags.forEach((flag, index) => {
            const panel = 5 - index;
            const outBus = flag & 3;
            const add = (flag & 4) !== 0;
            const inBus = (flag >> 4) & 3;
            result[panel].feedback = (flag & 0xc0) === 0xc0;
            if (inBus > 0) {
                writers[inBus - 1].forEach(writer => result[writer].targets.push(panel + 1));
            }
            if (outBus === 0) {
                result[panel].carrier = true;
            }
            else if (add) {
                writers[outBus - 1].push(panel);
            }
            else {
                writers[outBus - 1] = [panel];
            }
        });
        result.forEach(role => role.targets.sort((a, b) => a - b));
        return result;
    };
    // Transpose 0..48 around 24 = C3 (the DX7 panel's key display)
    Tubular.Transposes = Array.from({ length: 49 }, (_, index) => {
        const names = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
        return `${names[index % 12]}${Math.floor(index / 12) + 1}`;
    });
})(Tubular || (Tubular = {}));
export class TubularDeviceBoxAdapter {
    constructor(context, box) {
        _TubularDeviceBoxAdapter_instances.add(this);
        this.type = "instrument";
        this.accepts = "midi";
        this.manualUrl = DeviceManualUrls.Tubular;
        _TubularDeviceBoxAdapter_context.set(this, void 0);
        _TubularDeviceBoxAdapter_box.set(this, void 0);
        _TubularDeviceBoxAdapter_parametric.set(this, void 0);
        __classPrivateFieldSet(this, _TubularDeviceBoxAdapter_context, context, "f");
        __classPrivateFieldSet(this, _TubularDeviceBoxAdapter_box, box, "f");
        __classPrivateFieldSet(this, _TubularDeviceBoxAdapter_parametric, new ParameterAdapterSet(__classPrivateFieldGet(this, _TubularDeviceBoxAdapter_context, "f")), "f");
        this.namedParameter = __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_instances, "m", _TubularDeviceBoxAdapter_wrapParameters).call(this, box);
    }
    get box() { return __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_box, "f").address; }
    get spectrum() { return __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_box, "f").address.append(0xFFF); }
    get labelField() { return __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_box, "f").label; }
    get iconField() { return __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_box, "f").icon; }
    get defaultTrackType() { return TrackType.Notes; }
    get enabledField() { return __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_box, "f").enabled; }
    get minimizedField() { return __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_box, "f").minimized; }
    get acceptsMidiEvents() { return true; }
    deviceHost() {
        return __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_context, "f").boxAdapters
            .adapterFor(__classPrivateFieldGet(this, _TubularDeviceBoxAdapter_box, "f").host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    *labeledAudioOutputs() {
        yield { address: this.address, label: this.labelField.getValue(), children: () => Option.None };
    }
    terminate() {
        __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_parametric, "f").terminate();
    }
}
_TubularDeviceBoxAdapter_context = new WeakMap(), _TubularDeviceBoxAdapter_box = new WeakMap(), _TubularDeviceBoxAdapter_parametric = new WeakMap(), _TubularDeviceBoxAdapter_instances = new WeakSet(), _TubularDeviceBoxAdapter_wrapParameters = function _TubularDeviceBoxAdapter_wrapParameters(box) {
    const VoiceModes = [VoicingMode.Monophonic, VoicingMode.Polyphonic];
    const byte = (field, max, name) => __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_parametric, "f").createParameter(field, ValueMapping.linearInteger(0, max), StringMapping.numeric({ unit: "", fractionDigits: 0 }), name);
    const choice = (field, labels, name) => __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_parametric, "f").createParameter(field, ValueMapping.linearInteger(0, labels.length - 1), StringMapping.indices("", labels), name);
    const operator = (fields, index) => {
        const prefix = `OP${index + 1}`;
        return {
            rate1: byte(fields.rate1, 99, `${prefix} Rate 1`),
            rate2: byte(fields.rate2, 99, `${prefix} Rate 2`),
            rate3: byte(fields.rate3, 99, `${prefix} Rate 3`),
            rate4: byte(fields.rate4, 99, `${prefix} Rate 4`),
            level1: byte(fields.level1, 99, `${prefix} Level 1`),
            level2: byte(fields.level2, 99, `${prefix} Level 2`),
            level3: byte(fields.level3, 99, `${prefix} Level 3`),
            level4: byte(fields.level4, 99, `${prefix} Level 4`),
            breakPoint: byte(fields.breakPoint, 99, `${prefix} Break Point`),
            leftDepth: byte(fields.leftDepth, 99, `${prefix} Left Depth`),
            rightDepth: byte(fields.rightDepth, 99, `${prefix} Right Depth`),
            leftCurve: choice(fields.leftCurve, Tubular.Curves, `${prefix} Left Curve`),
            rightCurve: choice(fields.rightCurve, Tubular.Curves, `${prefix} Right Curve`),
            rateScaling: byte(fields.rateScaling, 7, `${prefix} Rate Scaling`),
            ampModSens: byte(fields.ampModSens, 3, `${prefix} Amp Mod Sens`),
            velocitySens: byte(fields.velocitySens, 7, `${prefix} Velocity Sens`),
            outputLevel: byte(fields.outputLevel, 99, `${prefix} Level`),
            mode: choice(fields.mode, Tubular.Modes, `${prefix} Mode`),
            coarse: byte(fields.coarse, 31, `${prefix} Coarse`),
            fine: byte(fields.fine, 99, `${prefix} Fine`),
            detune: choice(fields.detune, Tubular.Detunes, `${prefix} Detune`),
            enabled: choice(fields.enabled, Tubular.Switch, `${prefix} Switch`)
        };
    };
    return {
        cutoff: __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_parametric, "f").createParameter(box.cutoff, ValueMapping.unipolar(), StringMapping.percent({ fractionDigits: 0 }), "Cutoff", 1.0),
        resonance: __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_parametric, "f").createParameter(box.resonance, ValueMapping.unipolar(), StringMapping.percent({ fractionDigits: 0 }), "Resonance"),
        volume: __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_parametric, "f").createParameter(box.volume, ValueMapping.unipolar(), StringMapping.percent({ fractionDigits: 0 }), "Volume", 1.0),
        voicingMode: __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_parametric, "f").createParameter(box.voicingMode, ValueMapping.values(VoiceModes), StringMapping.values("", VoiceModes, ["mono", "poly"]), "Play Mode", 0.5),
        tune: __classPrivateFieldGet(this, _TubularDeviceBoxAdapter_parametric, "f").createParameter(box.tune, ValueMapping.linear(-100, 100), StringMapping.numeric({ unit: "ct", fractionDigits: 0 }), "Tune", 0.5),
        algorithm: choice(box.algorithm, Tubular.Algorithms, "Algorithm"),
        feedback: byte(box.feedback, 7, "Feedback"),
        oscKeySync: choice(box.oscKeySync, Tubular.Switch, "Osc Key Sync"),
        lfo: {
            speed: byte(box.lfo.speed, 99, "LFO Speed"),
            delay: byte(box.lfo.delay, 99, "LFO Delay"),
            pmDepth: byte(box.lfo.pmDepth, 99, "LFO PM Depth"),
            amDepth: byte(box.lfo.amDepth, 99, "LFO AM Depth"),
            sync: choice(box.lfo.sync, Tubular.Switch, "LFO Key Sync"),
            wave: choice(box.lfo.wave, Tubular.LfoWaves, "LFO Wave")
        },
        pitchModSens: byte(box.pitchModSens, 7, "Pitch Mod Sens"),
        transpose: choice(box.transpose, Tubular.Transposes, "Transpose"),
        pitchEnvelope: {
            rate1: byte(box.pitchEnvelope.rate1, 99, "Pitch EG Rate 1"),
            rate2: byte(box.pitchEnvelope.rate2, 99, "Pitch EG Rate 2"),
            rate3: byte(box.pitchEnvelope.rate3, 99, "Pitch EG Rate 3"),
            rate4: byte(box.pitchEnvelope.rate4, 99, "Pitch EG Rate 4"),
            level1: byte(box.pitchEnvelope.level1, 99, "Pitch EG Level 1"),
            level2: byte(box.pitchEnvelope.level2, 99, "Pitch EG Level 2"),
            level3: byte(box.pitchEnvelope.level3, 99, "Pitch EG Level 3"),
            level4: byte(box.pitchEnvelope.level4, 99, "Pitch EG Level 4")
        },
        operators: box.operators.fields().map(operator)
    };
};
